/* eslint-disable prettier/prettier */
import React, { useState } from 'react'
import { Button, Card, Typography } from '@material-ui/core'
import { useRouter } from 'next/router'

import { useProfileFactorySausageCardStyles } from './index.styles'
import { components } from '@plandi/common/src/generated'
import { URLS } from 'src/router/urls'
import { ReviewsModal, TranslationDictionary } from '@plandi/common'
import { ReactComponent as CrownIcon } from '../../../../assets/crown.svg'
import { PROFILE_TYPE } from '@plandi/common/src/components/profiles/profiles.constants'
import Image from 'next/image'

type ProfileFactorySausageCardProps =
  components['schemas']['ProfileFactoryResource'] & {
    translate?: TranslationDictionary['data']
    locale: string
  }

export const ProfileFactorySausageCard: React.FC<
  ProfileFactorySausageCardProps
> = (props) => {
  const [isReviewsModalOpened, setIsReviewsModalOpened] = useState(false)
  const classes = useProfileFactorySausageCardStyles()
  const router = useRouter()
  const isOnLine = true

  const specialization = props.mainActivitySpecializations?.map((el) => el.name)

  return (
    <Card className={classes.card}>
      {props.isPremium && (
        <div className={classes.premium}>
          <Typography className={classes.premiumTitle}>Premium</Typography>
          <CrownIcon />
        </div>
      )}
      <div className={isOnLine ? classes.cardTop : ''}>
        {props.avatarUrl && !props.avatarUrl?.includes('lorempixel.com') ? (
          <Image
            width={92}
            height={92}
            className={classes.avatarImage}
            src={props.avatarUrl}
            alt=""
          />
        ) : (
          <div className={classes.defaultImg}>
            {props.name && props.name[0]}
          </div>
        )}
      </div>
      <div className={classes.specialistInfo}>
        <Typography variant="body2" component="p" className={classes.name}>
          {props.name}
        </Typography>
        <Button
          onClick={() => setIsReviewsModalOpened(true)}
          variant="text"
          color="primary"
          className={classes.reviews}
        >
          {props.translate?.reviews ?? 'Отзывы'}
          <span className={classes.reviewsCount}>
            ({props.review_count || 0})
          </span>
        </Button>
      </div>
      <Typography
        variant="body2"
        component="p"
        className={classes.specialization}
      >
        {specialization}
      </Typography>
      <div className={classes.cardContainer}>
        <Button
          className={classes.cardButton}
          variant="outlined"
          color="secondary"
          onClick={() =>
            router.push({
              pathname: URLS.profileFactory.resume,
              query: {
                profileId: props.id,
                slugName: props.slug_name || 'no-slug-name'
              }
            })
          }
        >
          {props.translate?.['job-site']?.['companies-page']?.[
            'more-detailed'
          ] ?? 'Подробнее'}
        </Button>
      </div>
      {isReviewsModalOpened && (
        <ReviewsModal
          open={isReviewsModalOpened}
          profileName={props.name}
          handleClose={() => setIsReviewsModalOpened(false)}
          profileId={props.id as number}
          profileType={PROFILE_TYPE.FACTORY}
          profileSlugName={props.slug_name}
          translate={props.translate}
          locale={props.locale}
        />
      )}
    </Card>
  )
}
